import { useCallback, useMemo } from 'react'

import {
  ACCESS_TOKEN_STORAGE_KEY,
  PROFILE_SESSION_STORAGE_KEYS,
} from '../../constants'
import { useCreditCardState } from '../useCreditCardState'
import { useLogoutApi } from '../useLogoutApi'
import { REGISTRATION_STORAGE_KEY } from '../useRegistrationState'

// The guest's personal data must not outlive the session on a shared device,
// otherwise the next person's form is pre-filled with it.
const clearGuestStorage = () => {
  // Each storage is cleared independently: blocked storage throws, and that
  // must neither skip the other one nor stop the logout itself.
  try {
    PROFILE_SESSION_STORAGE_KEYS.forEach((key) =>
      sessionStorage.removeItem(key)
    )
  } catch (e) {
    // Storage unavailable: nothing was persisted there.
  }
  try {
    localStorage.removeItem(REGISTRATION_STORAGE_KEY)
  } catch (e) {
    // Storage unavailable: nothing was persisted there.
  }
}

export const useLogout = () => {
  const token = useMemo(() => {
    try {
      return sessionStorage.getItem(ACCESS_TOKEN_STORAGE_KEY) ?? ''
    } catch (e) {
      return ''
    }
  }, [])
  const { trigger } = useLogoutApi(token)
  const { onClearCreditCardState } = useCreditCardState()

  const onLogout = useCallback(async () => {
    clearGuestStorage()
    // The full page load below also drops the in-memory card, but clear it
    // explicitly so it does not depend on that.
    onClearCreditCardState()

    try {
      await trigger()
    } catch (e) {
      // Token maybe expired
      // Do nothing
    } finally {
      // TODO When logout at root, does not re-render.
      // So currently use location.assign('/')
      window.location.assign('/')
    }
  }, [onClearCreditCardState, trigger])

  return { onLogout }
}
